/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VehicleList
 */
export interface VehicleList {
    /**
     * 
     * @type {boolean}
     * @memberof VehicleList
     */
    vehicleStatus: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleList
     */
    vehicleSerialNumber: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleList
     */
    vehiclePhoneImei: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleList
     */
    vehicleDeviceSerialNumber: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleList
     */
    vehicleManufacturer: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleList
     */
    vehicleModel: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleList
     */
    vehicleEngineType: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleList
     */
    vehicleManufactureYear: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleList
     */
    vehicleShockProfile: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleList
     */
    vehiclePreOpsChecklist: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleList
     */
    vehicleChecklistOverride: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleList
     */
    vehicleIdleAutoLogoutAfter: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleList
     */
    vehicleLastSynchronizedAt: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleList
     */
    vehiclePurchaseDateOrContractTermStart: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleList
     */
    vehicleContractTermEnd: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleList
     */
    vehicleContractDaysRemaining: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleList
     */
    vehiclePurchaseCost: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleList
     */
    vehicleMonthlyCost: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleList
     */
    vehicleInitialOperatingHours: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleList
     */
    vehicleCurrentOperatingHours: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleList
     */
    vehicleLastMaintenanceOperatingHours: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleList
     */
    vehicleLastMaintenanceDate: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleList
     */
    vehicleNextMaintenanceHours: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleList
     */
    vehicleMaintenanceInterval: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleList
     */
    vehicleMaintenanceNotificationAt: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleList
     */
    vehicleMaintenanceLockdown: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleList
     */
    vehicleHoursUntilNextMaintenance: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleList
     */
    vehicleTypeLabel: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleList
     */
    departmentLabel: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleList
     */
    vehicleGroupLabel: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleList
     */
    userFullName: boolean;
}

/**
 * Check if a given object implements the VehicleList interface.
 */
export function instanceOfVehicleList(value: object): value is VehicleList {
    if (!('vehicleStatus' in value) || value['vehicleStatus'] === undefined) return false;
    if (!('vehicleSerialNumber' in value) || value['vehicleSerialNumber'] === undefined) return false;
    if (!('vehiclePhoneImei' in value) || value['vehiclePhoneImei'] === undefined) return false;
    if (!('vehicleDeviceSerialNumber' in value) || value['vehicleDeviceSerialNumber'] === undefined) return false;
    if (!('vehicleManufacturer' in value) || value['vehicleManufacturer'] === undefined) return false;
    if (!('vehicleModel' in value) || value['vehicleModel'] === undefined) return false;
    if (!('vehicleEngineType' in value) || value['vehicleEngineType'] === undefined) return false;
    if (!('vehicleManufactureYear' in value) || value['vehicleManufactureYear'] === undefined) return false;
    if (!('vehicleShockProfile' in value) || value['vehicleShockProfile'] === undefined) return false;
    if (!('vehiclePreOpsChecklist' in value) || value['vehiclePreOpsChecklist'] === undefined) return false;
    if (!('vehicleChecklistOverride' in value) || value['vehicleChecklistOverride'] === undefined) return false;
    if (!('vehicleIdleAutoLogoutAfter' in value) || value['vehicleIdleAutoLogoutAfter'] === undefined) return false;
    if (!('vehicleLastSynchronizedAt' in value) || value['vehicleLastSynchronizedAt'] === undefined) return false;
    if (!('vehiclePurchaseDateOrContractTermStart' in value) || value['vehiclePurchaseDateOrContractTermStart'] === undefined) return false;
    if (!('vehicleContractTermEnd' in value) || value['vehicleContractTermEnd'] === undefined) return false;
    if (!('vehicleContractDaysRemaining' in value) || value['vehicleContractDaysRemaining'] === undefined) return false;
    if (!('vehiclePurchaseCost' in value) || value['vehiclePurchaseCost'] === undefined) return false;
    if (!('vehicleMonthlyCost' in value) || value['vehicleMonthlyCost'] === undefined) return false;
    if (!('vehicleInitialOperatingHours' in value) || value['vehicleInitialOperatingHours'] === undefined) return false;
    if (!('vehicleCurrentOperatingHours' in value) || value['vehicleCurrentOperatingHours'] === undefined) return false;
    if (!('vehicleLastMaintenanceOperatingHours' in value) || value['vehicleLastMaintenanceOperatingHours'] === undefined) return false;
    if (!('vehicleLastMaintenanceDate' in value) || value['vehicleLastMaintenanceDate'] === undefined) return false;
    if (!('vehicleNextMaintenanceHours' in value) || value['vehicleNextMaintenanceHours'] === undefined) return false;
    if (!('vehicleMaintenanceInterval' in value) || value['vehicleMaintenanceInterval'] === undefined) return false;
    if (!('vehicleMaintenanceNotificationAt' in value) || value['vehicleMaintenanceNotificationAt'] === undefined) return false;
    if (!('vehicleMaintenanceLockdown' in value) || value['vehicleMaintenanceLockdown'] === undefined) return false;
    if (!('vehicleHoursUntilNextMaintenance' in value) || value['vehicleHoursUntilNextMaintenance'] === undefined) return false;
    if (!('vehicleTypeLabel' in value) || value['vehicleTypeLabel'] === undefined) return false;
    if (!('departmentLabel' in value) || value['departmentLabel'] === undefined) return false;
    if (!('vehicleGroupLabel' in value) || value['vehicleGroupLabel'] === undefined) return false;
    if (!('userFullName' in value) || value['userFullName'] === undefined) return false;
    return true;
}

export function VehicleListFromJSON(json: any): VehicleList {
    return VehicleListFromJSONTyped(json, false);
}

export function VehicleListFromJSONTyped(json: any, ignoreDiscriminator: boolean): VehicleList {
    if (json == null) {
        return json;
    }
    return {
        
        'vehicleStatus': json['vehicleStatus'],
        'vehicleSerialNumber': json['vehicleSerialNumber'],
        'vehiclePhoneImei': json['vehiclePhoneImei'],
        'vehicleDeviceSerialNumber': json['vehicleDeviceSerialNumber'],
        'vehicleManufacturer': json['vehicleManufacturer'],
        'vehicleModel': json['vehicleModel'],
        'vehicleEngineType': json['vehicleEngineType'],
        'vehicleManufactureYear': json['vehicleManufactureYear'],
        'vehicleShockProfile': json['vehicleShockProfile'],
        'vehiclePreOpsChecklist': json['vehiclePreOpsChecklist'],
        'vehicleChecklistOverride': json['vehicleChecklistOverride'],
        'vehicleIdleAutoLogoutAfter': json['vehicleIdleAutoLogoutAfter'],
        'vehicleLastSynchronizedAt': json['vehicleLastSynchronizedAt'],
        'vehiclePurchaseDateOrContractTermStart': json['vehiclePurchaseDateOrContractTermStart'],
        'vehicleContractTermEnd': json['vehicleContractTermEnd'],
        'vehicleContractDaysRemaining': json['vehicleContractDaysRemaining'],
        'vehiclePurchaseCost': json['vehiclePurchaseCost'],
        'vehicleMonthlyCost': json['vehicleMonthlyCost'],
        'vehicleInitialOperatingHours': json['vehicleInitialOperatingHours'],
        'vehicleCurrentOperatingHours': json['vehicleCurrentOperatingHours'],
        'vehicleLastMaintenanceOperatingHours': json['vehicleLastMaintenanceOperatingHours'],
        'vehicleLastMaintenanceDate': json['vehicleLastMaintenanceDate'],
        'vehicleNextMaintenanceHours': json['vehicleNextMaintenanceHours'],
        'vehicleMaintenanceInterval': json['vehicleMaintenanceInterval'],
        'vehicleMaintenanceNotificationAt': json['vehicleMaintenanceNotificationAt'],
        'vehicleMaintenanceLockdown': json['vehicleMaintenanceLockdown'],
        'vehicleHoursUntilNextMaintenance': json['vehicleHoursUntilNextMaintenance'],
        'vehicleTypeLabel': json['vehicleTypeLabel'],
        'departmentLabel': json['departmentLabel'],
        'vehicleGroupLabel': json['vehicleGroupLabel'],
        'userFullName': json['userFullName'],
    };
}

export function VehicleListToJSON(json: any): VehicleList {
    return VehicleListToJSONTyped(json, false);
}

export function VehicleListToJSONTyped(value?: VehicleList | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'vehicleStatus': value['vehicleStatus'],
        'vehicleSerialNumber': value['vehicleSerialNumber'],
        'vehiclePhoneImei': value['vehiclePhoneImei'],
        'vehicleDeviceSerialNumber': value['vehicleDeviceSerialNumber'],
        'vehicleManufacturer': value['vehicleManufacturer'],
        'vehicleModel': value['vehicleModel'],
        'vehicleEngineType': value['vehicleEngineType'],
        'vehicleManufactureYear': value['vehicleManufactureYear'],
        'vehicleShockProfile': value['vehicleShockProfile'],
        'vehiclePreOpsChecklist': value['vehiclePreOpsChecklist'],
        'vehicleChecklistOverride': value['vehicleChecklistOverride'],
        'vehicleIdleAutoLogoutAfter': value['vehicleIdleAutoLogoutAfter'],
        'vehicleLastSynchronizedAt': value['vehicleLastSynchronizedAt'],
        'vehiclePurchaseDateOrContractTermStart': value['vehiclePurchaseDateOrContractTermStart'],
        'vehicleContractTermEnd': value['vehicleContractTermEnd'],
        'vehicleContractDaysRemaining': value['vehicleContractDaysRemaining'],
        'vehiclePurchaseCost': value['vehiclePurchaseCost'],
        'vehicleMonthlyCost': value['vehicleMonthlyCost'],
        'vehicleInitialOperatingHours': value['vehicleInitialOperatingHours'],
        'vehicleCurrentOperatingHours': value['vehicleCurrentOperatingHours'],
        'vehicleLastMaintenanceOperatingHours': value['vehicleLastMaintenanceOperatingHours'],
        'vehicleLastMaintenanceDate': value['vehicleLastMaintenanceDate'],
        'vehicleNextMaintenanceHours': value['vehicleNextMaintenanceHours'],
        'vehicleMaintenanceInterval': value['vehicleMaintenanceInterval'],
        'vehicleMaintenanceNotificationAt': value['vehicleMaintenanceNotificationAt'],
        'vehicleMaintenanceLockdown': value['vehicleMaintenanceLockdown'],
        'vehicleHoursUntilNextMaintenance': value['vehicleHoursUntilNextMaintenance'],
        'vehicleTypeLabel': value['vehicleTypeLabel'],
        'departmentLabel': value['departmentLabel'],
        'vehicleGroupLabel': value['vehicleGroupLabel'],
        'userFullName': value['userFullName'],
    };
}

